import { TableColumnItem, TableColumnTypeEnum } from '@ui-lib/components';

export const getRolesTableColumnsConfig = (): TableColumnItem[] => [
  {
    propName: 'name',
    captionTranslateKey: 'monitoring.roles.columns.name',
    type: TableColumnTypeEnum.Text,
  },
];
